/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Foot_CliInputs */

const en_mk_foot_cli = /** @type {(inputs: Mk_Foot_CliInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CLI`)
};

const id_mk_foot_cli = /** @type {(inputs: Mk_Foot_CliInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CLI`)
};

/**
* | output |
* | --- |
* | "CLI" |
*
* @param {Mk_Foot_CliInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_foot_cli = /** @type {((inputs?: Mk_Foot_CliInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Foot_CliInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_foot_cli(inputs)
	return en_mk_foot_cli(inputs)
});